module.exports = __webpack_public_path__ + "img/flfg1.8bf393dc.png";